import React from "react";
import Navbar from "../components/LandingPageNew/Navbar";
import Footer from "../components/LandingPageNew/Footer";
const IMPRESSUM_SECTIONS = [
    {
        title: "Angaben gemäß § 5 TMG",
        items: [
            { label: "Unternehmen", value: "UNEVA - Eine Marke der Montrevex Gruppe" },
            { label: "Adresse", value: "Gelsenkirchenerstr. 12, 28199 Bremen" },
        ],
    },
    {
        title: "Vertreten durch",
        items: [
            // { label: "Geschäftsführer", value: "Kevin Rahman" },
            { label: "Geschäftsführer", value: "Nicolas Georgiades" },


        ],
    },
    {
        title: "Registereintrag",
        items: [
            { label: "Eintragung", value: "Eintragung im Handelsregister." },
            { label: "Registergericht", value: "Amtsgericht Bremen" },
            // { label: "Registernummer", value: "HRB 40560" },
        ],
    },
    
  
    // {
    //     title: "Umsatzsteuer",
    //     items: [
    //         {
    //             label: "USt-IdNr.",
    //             value:
    //                 "Umsatzsteuer-Identifikationsnummer gemäß §27 a Umsatzsteuergesetz:",
    //         },
    //     ],
    // },
    {
        title: "Kontakt",
        items: [
            { label: "Telefon", value: "+49 (0)421 36583008" },
            { label: "E-Mail", value: "anfrage@uneva.de", type: "email" },
            { label: "Steuernummer", value: "60320720L" },
        ],
    },
    {
        title: "EU-Streitschlichtung",
        prose: [
            "Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:",
        ],
        items: [
            {
                label: "OS-Plattform",
                href: "https://ec.europa.eu/consumers/odr",
                linkText: "https://ec.europa.eu/consumers/odr",
            },
        ],
        proseAfter: [
            "Unsere E-Mail-Adresse finden Sie oben im Impressum.",
        ],
    },
    {
        title: "Verbraucherstreitbeilegung / Universalschlichtungsstelle",
        prose: [
            "Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.",
        ],
    },
    {
        title: "Haftungsausschluss",
        subsections: [
            {
                subtitle: "Haftung für Links",
                prose: [
                    "Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.",
                    "Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.",
                ],
            },
            {
                subtitle: "Haftung für Inhalte",
                prose: [
                    "Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich.",
                    "Nach § 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.",
                ],
            },
        ],
    },
    {
        title: "Galerie",
        items: [
            {
                label: "Source",
                href: "https://www.freepik.com/",
                linkText: "https://www.freepik.com/",
            },
        ],
    },
    {
        title: "Urheberrecht",
        prose: [
            "Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.",
            "Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.",
        ],
    },
];

function Row({ label, value, href, linkText, note, type }) {
    const renderValue = () => {
        if (type === "email" && value) {
            return (
                <a
                    href={`mailto:${value}`}
                    className="text-[#0b2b40] underline underline-offset-4 decoration-[#0b2b40]/30 hover:decoration-[#0b2b40]"
                >
                    {value}
                </a>
            );
        }

        if (href) {
            return (
                <a
                    href={href}
                    target="_blank"
                    rel="noreferrer"
                    className="text-[#0b2b40] underline underline-offset-4 decoration-[#0b2b40]/30 hover:decoration-[#0b2b40]"
                >
                    {linkText || href}
                </a>
            );
        }

        return <span className="text-slate-700">{value}</span>;
    };

    return (
        <div className="grid grid-cols-1 gap-2 py-3 md:grid-cols-12 md:gap-4">
            <div className="md:col-span-4">
                <div className="text-sm font-semibold text-[#0b2b40]">{label}</div>
                {note ? (
                    <div className="mt-1 text-xs text-slate-500">{note}</div>
                ) : null}
            </div>

            <div className="md:col-span-8">
                <div className="text-sm leading-6">{renderValue()}</div>
            </div>
        </div>
    );
}

function Section({ section }) {
    return (
        <section className="rounded-2xl border border-slate-200 bg-white shadow-[0_18px_60px_-35px_rgba(15,23,42,0.35)]">
            <div className="flex items-start justify-between gap-6 border-b border-slate-100 px-5 py-4 sm:px-6">
                <h2 className="text-base font-bold tracking-tight text-[#0b2b40] sm:text-lg">
                    {section.title}
                </h2>
                <span className="hidden h-2 w-2 shrink-0 rounded-full bg-emerald-500 sm:block" />
            </div>

            <div className="px-5 py-4 sm:px-6">
                {/* prose (only once) */}
                {section.prose?.length ? (
                    <div className="space-y-3 pb-3">
                        {section.prose.map((p, i) => (
                            <p key={i} className="text-sm leading-6 text-slate-700">
                                {p}
                            </p>
                        ))}
                    </div>
                ) : null}

                {/* items */}
                {section.items?.length ? (
                    <div className="divide-y divide-slate-100">
                        {section.items.map((it, idx) => (
                            <Row key={idx} {...it} />
                        ))}
                    </div>
                ) : null}

                {/* proseAfter */}
                {section.proseAfter?.length ? (
                    <div className="space-y-3 pt-3">
                        {section.proseAfter.map((p, i) => (
                            <p key={i} className="text-sm leading-6 text-slate-700">
                                {p}
                            </p>
                        ))}
                    </div>
                ) : null}

                {/* subsections */}
                {section.subsections?.length ? (
                    <div className="space-y-6">
                        {section.subsections.map((sub, i) => (
                            <div
                                key={i}
                                className="rounded-xl border border-slate-200 bg-slate-50 p-4"
                            >
                                <h3 className="text-sm font-bold text-[#0b2b40]">
                                    {sub.subtitle}
                                </h3>
                                <div className="mt-2 space-y-3">
                                    {sub.prose.map((p, j) => (
                                        <p key={j} className="text-sm leading-6 text-slate-700">
                                            {p}
                                        </p>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                ) : null}
            </div>
        </section>
    );
}


/**
 * Impressum / Legal Notice Page Section
 * - React + Tailwind
 * - Premium card UI, responsive
 */
export default function Impressum() {
    return (
        <>
            <Navbar />
            <div className="bg-white mt-32">
                <div className="mx-auto w-[90%] 2xl:w-[70%]">
                    {/* Header */}
                    <div className="mb-8 rounded-2xl border border-slate-200 bg-gradient-to-b from-slate-50 to-white p-6 shadow-[0_18px_60px_-35px_rgba(15,23,42,0.35)] sm:p-8">
                        <div className="inline-flex items-center gap-2 rounded-full border border-emerald-200 bg-emerald-50 px-3 py-1 text-xs font-semibold text-emerald-700">
                            Rechtliches
                        </div>
                        <h1 className="mt-3 h1-mb h1-md h1-lg h1-2xl">
                            Impressum
                        </h1>
                        <p className="mt-2 max-w-3xl text-sm leading-6 text-slate-600">
                            Angaben gemäß § 5 TMG sowie weitere rechtliche Hinweise, Kontaktinformationen,
                            Haftungsausschluss und Urheberrecht.
                        </p>
                    </div>

                    {/* Content */}
                    <div className="grid grid-cols-1 gap-6">
                        {IMPRESSUM_SECTIONS.map((section, idx) => (
                            <Section key={idx} section={section} />
                        ))}
                    </div>

                    {/* Footer note */}

                </div>
            </div>
            <Footer />
        </>

    );
}
